export default __webpack_public_path__ + "static/202309各班名單公告-717b13016afb51fdafa07c3c8abfd31f.pdf";